import { usePublicApiClient } from '@guiker/react-framework'
import { PublicApiClient } from '@guiker/rental-listing-shared'

export const usePublicListingApiClient = usePublicApiClient(PublicApiClient)
